export const EG_STORE_KEY = 'engagement-goals'
